import { useEffect } from 'react';
import { useCompanySettings } from './useCompanySettings';
import Color from 'color';

export function usePrimaryColor() {
  const { primaryColor, secondaryColor } = useCompanySettings();

  useEffect(() => {
    const root = document.documentElement;
    const basePrimaryColor = primaryColor || '#3B82F6'; // blue-500 como padrão
    const baseSecondaryColor = secondaryColor || '#10B981'; // emerald-500 como padrão

    try {
      const primaryColorObj = Color(basePrimaryColor);
      const secondaryColorObj = Color(baseSecondaryColor);
      
      // Define a cor principal
      root.style.setProperty('--primary-color', basePrimaryColor);
      
      // Calcula e define variações da cor principal
      root.style.setProperty('--primary-color-hover', primaryColorObj.darken(0.1).hex());
      root.style.setProperty('--primary-color-light', primaryColorObj.mix(Color('#FFFFFF'), 0.9).hex());
      root.style.setProperty('--primary-color-dark', primaryColorObj.darken(0.3).hex());

      // Define a cor secundária
      root.style.setProperty('--secondary-color', baseSecondaryColor);
      
      // Calcula e define variações da cor secundária
      root.style.setProperty('--secondary-color-hover', secondaryColorObj.darken(0.1).hex());
      root.style.setProperty('--secondary-color-light', secondaryColorObj.mix(Color('#FFFFFF'), 0.9).hex());
      root.style.setProperty('--secondary-color-dark', secondaryColorObj.darken(0.3).hex());

      // Combinações para botões com inversão no hover
      root.style.setProperty('--btn-outline-bg', baseSecondaryColor);
      root.style.setProperty('--btn-outline-text', basePrimaryColor);
      root.style.setProperty('--btn-outline-border', basePrimaryColor);
      root.style.setProperty('--btn-outline-hover-bg', basePrimaryColor);
      root.style.setProperty('--btn-outline-hover-text', baseSecondaryColor);
      root.style.setProperty('--btn-outline-hover-border', basePrimaryColor);
    } catch (error) {
      console.error('Erro ao processar cores:', error);
      // Em caso de erro, volta para as cores padrão
      root.style.setProperty('--primary-color', '#3B82F6');
      root.style.setProperty('--primary-color-hover', '#2563EB');
      root.style.setProperty('--primary-color-light', '#EFF6FF');
      root.style.setProperty('--primary-color-dark', '#1E3A8A');
      
      root.style.setProperty('--secondary-color', '#10B981');
      root.style.setProperty('--secondary-color-hover', '#059669');
      root.style.setProperty('--secondary-color-light', '#ECFDF5');
      root.style.setProperty('--secondary-color-dark', '#047857');
      
      // Combinações padrão para botões com inversão
      root.style.setProperty('--btn-outline-bg', '#10B981');
      root.style.setProperty('--btn-outline-text', '#3B82F6');
      root.style.setProperty('--btn-outline-border', '#3B82F6');
      root.style.setProperty('--btn-outline-hover-bg', '#3B82F6');
      root.style.setProperty('--btn-outline-hover-text', '#10B981');
      root.style.setProperty('--btn-outline-hover-border', '#3B82F6');
    }
  }, [primaryColor, secondaryColor]);
} 